// Main CashierMutations

export const updateMainCashierList = (state, payload) => {
  state.mainCashierList = payload
}

export const fetchMainCashierInfo = (state, payload) => {
  state.mainCashierInfo = payload
}
